// Core
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Row, Col } from "react-flexbox-grid";
import SearchBar from "material-ui-search-bar";
import { BottomNavigationItem } from "material-ui/BottomNavigation";
import { NotificationContainer } from "react-notifications";
import FolderIcon from "material-ui/svg-icons/file/folder";
import ProjectSelect from "../projects/ProjectSelect";
import ProjectsIcon from "material-ui/svg-icons/image/collections-bookmark";
import ChecklistIcon from "material-ui/svg-icons/action/view-list";
import ActionSettings from "material-ui/svg-icons/action/settings";
import ReportIcon from "material-ui/svg-icons/action/description";
import IssuesIcon from "material-ui/svg-icons/action/assignment";
import NavigationLogo from "../../assets/navigation-logo.svg";

import { connect } from "react-redux";
import throttle from "lodash/throttle";
// import { Carousel } from "react-responsive-carousel";

// Actions
import { signOut, introHide } from "../../redux/auth/actions";
import { searchFiles, disableSearch } from "../../redux/files/actions";

// Selectors
import * as authSelectors from "../../redux/auth/selectors";
import * as projectSelectors from "../../redux/projects/selectors";

// Instruments
import { isIE } from "../../utils/navigator";

// Styles & assets
import "react-responsive-carousel/lib/styles/carousel.css";
import "react-notifications/lib/notifications.css";
import "./DashboardScreen.css";
import logo from "../../assets/logo.png";

const mapStateToProps = state => ({
  projectsList: projectSelectors.projectsList(state),
  showIntro: authSelectors.showIntro(state),
  userId: authSelectors.getUserId(state)
});

const mapDispatchToProps = {
  searchFiles,
  disableSearch,
  signOut,
  introHide
};

const LIST_ADMIN_ID = [
  "sms|591313fe961bda2fafb9f668",
  "sms|58dcadf2879f18288a8d980f",
  "sms|5c6181e0012d5b66906a4972"
];

class DashboardScreen extends Component {
  state = {
    searchPhrase: "",
    selectedItem: 0,
    disableSearch: true
  };

  componentWillMount() {
    const auth = JSON.parse(localStorage.getItem("auth0"));
    const persist = JSON.parse(localStorage.getItem("reduxPersist:auth"));
    if (!auth || !auth.id_token || !persist.user) {
      this.props.signOut();
      this.props.history.replace("/");
    }

    document.addEventListener("keydown", this._handleKeyDown.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.location.pathname === "/dashboard/projects" &&
        !this.state.disableSearch) ||
      nextProps.location.pathname === "/dashboard/checklist" ||
      nextProps.location.pathname === "/dashboard/issues" ||
      nextProps.location.pathname === "/dashboard/templates"
    ) {
      this.setState({
        disableSearch: true
      });
    } else if (
      nextProps.location.pathname !== "/dashboard/projects" &&
      this.state.disableSearch
    ) {
      this.setState({
        disableSearch: false
      });
    }
    this.setState({ searchPhrase: "" }, this._handleSearch);

    if (!isIE()) {
      document.body.classList.toggle("disable-scroll", nextProps.showIntro);
    }
  }

  componentWillUnmount() {
    // document.removeEventListener("click", this._handleDocumentClick, false);
  }

  /*handleSingOut = () => {
      this.props.signOut();
      window.location = '/';
  };*/

  _handleChangeSlide = selectedSlide => {
    this.setState({
      selectedSlide
    });
  };

  _handleSearchChange = value => {
    this.setState({ searchPhrase: value }, this._handleSearchThrottled);
  };

  _handleSearchRequest = () => this._handleSearchThrottled();

  _handleSearch = () => {
    const { searchPhrase } = this.state;
    const { projectsList, searchFiles, disableSearch } = this.props;
    const projectIDs = Object.keys(projectsList);

    if (searchPhrase.length === 0) {
      disableSearch();
    } else {
      searchFiles(searchPhrase, projectIDs);
    }
  };

  _handleSearchThrottled = throttle(this._handleSearch, 1000);

  _handleKeyDown(event) {
    const { introHide } = this.props;

    if (event.key === "Escape") {
      introHide();
      return false;
    }

    return true;
  }

  _handleClickIntroOverlay = event => {
    const { introHide } = this.props;
    if (event.target.className.indexOf("intro-overlay-row") === 0) {
      introHide();
    }
  };

  _isActiveProjectLink = (match, location) => {
    return location.pathname.startsWith("/dashboard/project");
  };

  _isActivePlansLink = (match, location) => {
    return location.pathname.startsWith("/dashboard/plans");
  };

  _isActiveSettingsLink = (match, location) => {
    return location.pathname.startsWith("/dashboard/settings");
  };

  _isActiveChecklistLink = (match, location) => {
    return location.pathname.startsWith("/dashboard/checklist");
  };

  _isActiveIssueLink = (match, location) => {
    return location.pathname.startsWith("/dashboard/issues");
  };

  _isActiveTemplatesLink = (match, location) => {
    return location.pathname.startsWith("/dashboard/templates");
  };

  _isActiveCategoryPage = location => {
    return location.pathname.startsWith("/dashboard/category") || location.pathname.startsWith("/dashboard/location");
  };

  _renderIntro = () => {
    const { showIntro, history } = this.props;
    const { location } = history;

    if (location.state && location.state.action === "upload") {
      return null;
    }

    if (!showIntro) {
      return null;
    }

    const className = isIE()
      ? "intro-carousel-frame-ie"
      : "intro-carousel-frame";

    return (
      <Row className="no-margin">
        {/*<Col xs={12} className="intro-overlay" onClick={this._handleClickIntroOverlay}>*/}
        {/*<Row center="xs" middle="xs" className="intro-overlay-body">*/}
        {/*<Col lg={8} md={9} xs={10} className={className}>*/}
        {/*<Carousel className="intro-carousel" showStatus={false} showArrows={true} selectedItem={this.state.selectedSlide} onChange={this._handleChangeSlide}>*/}
        {/*<Row center="xs" middle="xs" className="intro-slide intro-slide-1">*/}
        {/*<Col xs={12}>*/}
        {/*<div className="image-spacer">*/}
        {/*<img src={logo} width={173} height={138} />*/}
        {/*</div>*/}
        {/*<h1>Construction Pulses</h1>*/}
        {/*<p>One home for all your project’s information – organized and easy to find</p>*/}
        {/*</Col>*/}
        {/*</Row>*/}
        {/*<Row center="xs" middle="xs" className="intro-slide intro-slide-2">*/}
        {/*<Col xs={12}>*/}
        {/*<div className="image-spacer">*/}
        {/*<img src={require('../../assets/tutorial-2.png')} width={457} height={335} />*/}
        {/*</div>*/}
        {/*<h2>Auto uploaded from all of your team’s devices</h2>*/}
        {/*<p>Backup and view everything – photos, documents, communication, approvals or blueprints</p>*/}
        {/*</Col>*/}
        {/*</Row>*/}
        {/*<Row center="xs" middle="xs" className="intro-slide intro-slide-3">*/}
        {/*<Col xs={12}>*/}
        {/*<div className="image-spacer">*/}
        {/*<img src={require('../../assets/tutorial-3.png')} width={610} height={283} />*/}
        {/*</div>*/}
        {/*<h2>Automatically organized and searchable</h2>*/}
        {/*<p>See all your work organized by projects, members, categories, locations, dates and much more.*/}
        {/*Search by what you remember, no description needed</p>*/}
        {/*<button onClick={this.props.introHide}>Got it!</button>*/}
        {/*</Col>*/}
        {/*</Row>*/}
        {/*</Carousel>*/}
        {/*</Col>*/}
        {/*</Row>*/}
        {/*</Col>*/}
      </Row>
    );
  };

  render() {
    const { searchPhrase, userId } = this.props;

    return (
      <div>
        <NotificationContainer />
        {this._renderIntro()}
        <Row className="navigation top" middle="xs">
          <Col xs={4} sm={3} md={2}>
            <img
              src={logo}
              alt="Pulser"
              height={70}
              style={{
                margin: "0 20px"
              }}
            />
          </Col>
          {this._isActiveProjectLink(null, this.props.location) && (<ProjectSelect history={this.props.history}/>)}
          {/* {this._isActivePlansLink(null, this.props.location) && (<ProjectSelect />)} */}
          <Col xs={8} sm={9} md={10}>
            {!this.state.disableSearch &&
              !this._isActiveCategoryPage(this.props.location) &&
              !this._isActiveProjectLink(null, this.props.location) && (
                <>
                  <ProjectSelect history={this.props.history} />
                </>
              )
            }
          </Col>
        </Row>
        {!this._isActiveCategoryPage(this.props.location) && (
          <Row
            className="navigation left"
            style={{ padding: 0, background: "#fff" }}
          >
            <Col start="xs" xs={12}>

              <NavLink
                isActive={this._isActiveIssueLink}
                to="/dashboard/issues"
                title="Issues"
                className="files link"
                activeClassName="active"
              >
                <BottomNavigationItem
                  label="Issues"
                  icon={<IssuesIcon />}
                />
              </NavLink>

              <NavLink
                isActive={this._isActiveChecklistLink}
                to="/dashboard/checklist"
                title="Checklists"
                className="files link"
                activeClassName="active"
              >
                <BottomNavigationItem
                  label="Checklists settings"
                  icon={<ChecklistIcon />}
                />
              </NavLink>

              <NavLink
                isActive={this._isActiveProjectLink}
                to="/dashboard/projects"
                title="Projects"
                className="files link"
                activeClassName="active"
              >
                <BottomNavigationItem
                  label="Reports & Photos"
                  icon={<ProjectsIcon />}
                />
              </NavLink>

              <NavLink
                isActive={this._isActivePlansLink}
                to="/dashboard/plans"
                title="Plans"
                className="files link"
                activeClassName="active"
              >
                <BottomNavigationItem
                  label="Plans & Files"
                  icon={<ReportIcon />}
                />
              </NavLink>

              <a
                  href="https://beti.pro/quality"
                  title="Progress Table"
                  className="files link"
              >
                <BottomNavigationItem
                    label="Progress Table"
                    icon={<img src={NavigationLogo} style={{width: 72, height: 45}} alt="Progress Table"/>}
                />
              </a>

              <NavLink
                isActive={this._isActiveSettingsLink}
                to="/dashboard/settings"
                title="Settings"
                className="files link"
                activeClassName="active"
              >
                <BottomNavigationItem
                  label="Settings"
                  icon={<ActionSettings />}
                />
              </NavLink>
              {/* <NavLink
                isActive={this._isActiveTemplatesLink}
                to="/dashboard/templates"
                title="Templates"
                className="files link"
                activeClassName="active"
              >
                <BottomNavigationItem
                  label="Report Templates"
                  icon={<ReportIcon />}
                />
              </NavLink> */}
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardScreen);
